import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { useT } from "@/i18n";
import { NavA } from "./Nav";
import { openCookieSettings } from "@/lib/consent";
import { SocialLinks } from "./Social";

export const Footer = () => {
  const t = useT();
  return (
  <footer className="overflow-hidden bg-[#C26D38] px-5 pt-16 text-[#121110] sm:px-8" data-testid="site-footer">
    <div className="mx-auto max-w-[1500px]">
      <div className="flex flex-col justify-between gap-10 border-b border-[#121110]/20 pb-12 md:flex-row">
        <div className="flex flex-col gap-4">
          <Logo tone="dark" className="h-14" />
          <SocialLinks btnClass="border-[#121110]/40" />
        </div>
        <div className="grid grid-cols-2 gap-x-16 gap-y-3 font-mono text-xs uppercase tracking-[0.2em]">
          {[["Prodotti", "#prodotti"], ["Progetti", "#progetti"], ["Chi siamo", "/chi-siamo"], ["Contatti", "#contatti"]].map(([l, id]) => (
            <NavA key={id} to={id} className="tap nav-link text-left" data-testid={`footer-link-${id.slice(1)}`}>{t(`footer.${id.slice(1)}`, l)}</NavA>
          ))}
          <NavA to="/mappa-del-sito" className="tap nav-link text-left" data-testid="footer-link-sitemap">{t("map.title", "Mappa del sito")}</NavA>
          <NavA to="/cookie-policy" className="tap nav-link text-left" data-testid="footer-link-cookie-policy">{t("ck.policy", "Cookie policy")}</NavA>
          <button type="button" onClick={openCookieSettings} className="tap nav-link text-left uppercase" data-testid="footer-cookie-settings">{t("ck.settings", "Preferenze cookie")}</button>
        </div>
        <p className="font-mono text-xs uppercase leading-relaxed tracking-[0.15em]">Via Angelo Masini 12/14 · 40126 Bologna<br />Via Michele Utveggio 7 · 93100 Caltanissetta<br />Tel. 051 0830043 · WhatsApp 380 3758249</p>
        <p className="font-mono text-xs uppercase tracking-[0.2em]">© 2026 emma industrie<br />P.IVA IT03694561204</p>
      </div>
      <motion.p
        initial={{ y: "40%" }}
        whileInView={{ y: "0%" }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="select-none text-center font-display text-[30vw] font-extrabold lowercase leading-[0.78] tracking-[-0.06em]"
        style={{ fontStretch: "125%" }}
        aria-hidden="true"
      >
        emma
      </motion.p>
    </div>
  </footer>
  );
};
